export default __webpack_public_path__ + "static/media/Green0007.b6623d1d.png";